<template>
  <div :class="`dropdown-selector dropdown-selector-${type}`">
    <dropdown v-model="unfold" ref="dropdown"
              :not-close-elements="notClose">
      <btn :size="size" active v-if="prefix !== ''">{{ prefix }}</btn>
      <btn :type="type" class="dropdown-toggle" :size="size" :disabled="disabled">
        <strong v-html="label"></strong>&nbsp;&nbsp;<span class="caret"></span>
      </btn>
      <template slot="dropdown">
        <li v-for="(i, j) in lines"
            role="button"
            class="no-outline"
            :key="`selector-line-${j}`">
          <a role="button" @click="i.select()"
             class="item"
             :class="{ 'selected': i.selected }">
            <span >{{ i.label }}</span>
          </a>
        </li>
      </template>
    </dropdown>
  </div>
</template>
<script>
export default {
  name: 'dropdown-selector',

  props: {
    label: {
      type: String,
      default: 'default'
    },

    prefix: {
      type: String,
      default: ''
    },

    lines: {
      type: Array,
      required: true
    },

    keepOpen: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: ''
    },

    size: {
      type: String,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      unfold: false,
      isMounted: false
    }
  },

  methods: {
    leave: function () {
      this.unfold = false
    }
  },

  mounted: function () {
    this.isMounted = true
  },

  computed: {
    notClose: function () {
      if (!this.keepOpen || !this.isMounted) {
        return null
      }

      return [this.$refs.dropdown.$el]
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';

selector {
  color: #fc8375;
  font-weight: bold;
}

selector-item:hover {
  background-color: lighten(#fc8375, 20%);
  color: white;
}

selector-selected {
  font-weight: bold;
  background-color: #fc8375;
  color: white;

  &:hover {
    background-color: lighten(#fc8375, 10%);
    color: white;
  }
}
</style>
